<template>
  <Popup
    v-model:visible="visible"
    class="toast-wrapper"
    overlay-class="toast-wrapper"
    :visible.sync="visible"
    :close-on-click-overlay="false"
    :z-index="zIndex"
    @clickOverlay="onClickOverlay"
  >
    <div
      :class="classes(n(), n('$--box'), n(`${isTextToast ? 'text' : 'icon'}`))"
      :style="toastStyle"
    >
      <!-- 纯文本类型 -->
      <!-- 文本直接放在带 line-clamp 的容器上：LiteApp 下若文本被内层 span 包裹，
           引擎无法正确计算行数，英文会只显示一行 -->
      <div
        v-if="isTextToast"
        :class="classes(n('content-text'))"
        v-html="message"
      />
      <!-- 带Icon类型 -->
      <div
        v-else
        :class="classes(n('content-icon'))"
      >
        <!-- 图标 -->
        <component
          :is="toastIconComp"
          :class="classes({ [n('content-icon_loading')]: isLoadingToast })"
          width="80"
          height="80"
          color="#ffffff"
        />
        <!-- 文本 -->
        <div
          :class="classes(n('content-icon_text_common'), n(`${showDotLine ? 'content-icon_text_dot' : 'content-icon_text'}`))"
          v-html="message"
        />
        <!-- 底部加载Loading -->
        <div
          v-if="showDotLine"
          :class="classes(n('content-icon_dot'))"
        >
          <div :class="classes(n('content-icon_dot_item'))" />
          <div :class="classes(n('content-icon_dot_item'))" />
          <div :class="classes(n('content-icon_dot_item'))" />
        </div>
      </div>
    </div>
  </Popup>
</template>

<script lang="ts">
import { defineComponent, ref, computed, watch } from 'virtual-vue';
import { props } from './props';
import { emits } from './emits';
import { createNamespace } from '../utils/components';
import Popup from '../popup/popup.vue';
import { createZIndexManager, zIndexDefault } from '../use/useZIndex';
import { OkOIcon, CautionCircleIcon, LoadingIcon } from '@tencent/wphk-design-icons';

const { name, n, classes } = createNamespace('toast');

const initIndex = createZIndexManager('toast', zIndexDefault.toast);

export default defineComponent({
  name,
  components: { Popup },
  props,
  emits,
  setup(props, { emit }) {
    const zIndex = ref(initIndex.next());

    const toastStyle = computed(() => ({ zIndex: zIndex.value }));

    const isTextToast = computed(() => props.icon === 'text');

    const isLoadingToast = computed(() => props.icon === 'loading');

    const toastIconComp = computed(() => {
      if (props.icon === 'success') {
        return OkOIcon;
      }
      if (props.icon === 'fail') {
        return CautionCircleIcon;
      }
      if (props.icon === 'loading') {
        return LoadingIcon;
      }
      // 自定义 icon
      return props.icon;
    });

    const onClickOverlay = (e: Event) => {
      emit('clickOverlay', e);
    };

    watch(() => props.visible, (newVal) => {
      if (newVal) {
        zIndex.value = initIndex.next();
      }
    });

    return {
      n,
      classes,
      zIndex,
      toastStyle,
      isTextToast,
      isLoadingToast,
      toastIconComp,
      onClickOverlay,
    };
  },
});
</script>
